import styled from '@emotion/styled'
import {
  Button,
  InputAdornment,
  InputBase,
  InputBaseProps,
  Typography,
} from '@mui/material'
import { Box } from '@mui/system'
import BigNumber from 'bignumber.js'
import { AssetData } from 'constants/assets'
import { ZERO } from 'constants/number'
import { theme } from 'theme'
import CoreDivider from './CoreDivider'
import CoreToken from './CoreToken'

interface Props {
  assistiveText?: string
  inputBaseProps?: InputBaseProps
  assetDatas: AssetData[]
  onChange: (value: string) => void
  maxValue?: BigNumber
  safeValue?: BigNumber
  disabled?: boolean
  value: string
}

const CoreTokenInput = ({
  assistiveText,
  inputBaseProps,
  assetDatas,
  onChange,
  maxValue = ZERO,
  safeValue,
  disabled,
  value,
}: Props) => {
  const handleOnChange = (_value: string) => {
    const num = new BigNumber(_value)
    if ((!num.isNaN() && num.isPositive()) || _value === '') {
      onChange(_value)
    }
  }
  const handleOnMax = () => {
    if (safeValue) handleOnChange(BigNumber.min(safeValue, maxValue).toString())
    else handleOnChange(maxValue.toString())
  }
  return (
    <>
      <Box>
        <CustomInput
          {...inputBaseProps}
          type="number"
          fullWidth
          onChange={(e) => handleOnChange(e.target.value)}
          placeholder="Amount"
          value={value}
          disabled={disabled}
          sx={
            maxValue.eq(ZERO)
              ? {
                  '&:hover': {
                    outline: '2px solid #959595',
                  },
                  '&:focus-within': {
                    outline: '2px solid #959595',
                  },
                  '&:focus': {
                    outline: '2px solid #959595',
                  },
                }
              : {}
          }
          endAdornment={
            <InputAdornment position="end">
              <MaxBtn
                onClick={handleOnMax}
                disabled={disabled || maxValue.eq(ZERO)}
              >
                Max
              </MaxBtn>
              <CoreDivider color="grey" sx={{ marginX: '16px' }} />
              {assetDatas.length === 1 ? (
                <CoreToken
                  assetData={assetDatas[0]}
                  size={24}
                  withName
                  fontBold
                />
              ) : (
                <Box> TODO: Select token comp </Box>
              )}
            </InputAdornment>
          }
        />
      </Box>
      {assistiveText && (
        <Typography variant="caption"> {assistiveText} </Typography>
      )}
    </>
  )
}

export default CoreTokenInput

const CustomInput = styled(InputBase)`
  background: #f6f6f6;
  border-radius: 8px;
  padding: 12px 16px 11px 16px;
`

const MaxBtn = styled(Button)`
  background: rgba(227, 97, 57, 0.16);
  border-radius: 4px;
  height: 24px;
  width: 43px;
  font-size: 12px;
  font-weight: 600;
  align-content: center;
  :disabled {
    box-shadow: none;
    color: ${theme.palette.text.disabled};
    background: #d4d4d4;
    cursor: default;
  }
`
